import { IClientLogEntries } from "../../../models/configuration/pushback/IPushbackReport";
import { Action, ActionType } from "../../actions";

interface PushbackClientLogsState {
  loading: boolean;
  error: string | null;
  data: IClientLogEntries | null;
}

const initialState = { loading: false, error: null, data: null };

const pushbackClientLogsReducer = (
  state: PushbackClientLogsState = initialState,
  action: Action
): PushbackClientLogsState => {
  switch (action.type) {
    // GET DATA
    case ActionType.GET_PUSHBACK_CLIENT_LOGS:
      return { ...state, loading: true, error: null };
    case ActionType.GET_PUSHBACK_CLIENT_LOGS_FAILURE:
        return { ...state, loading: false, error: action.payload };
    case ActionType.GET_PUSHBACK_CLIENT_LOGS_SUCCESS:
        return { ...state, loading: false, error: null, data: action.payload };
    case ActionType.CONFIG_ID_CHANGED:
        return initialState;
    default:
        return state;
  }
};

export default pushbackClientLogsReducer;